// extracted by mini-css-extract-plugin
module.exports = {"avenir-font":"fonts_avenir-font__IYGrv","roboto-font":"fonts_roboto-font__1tF2X","gotham-font":"fonts_gotham-font__1JsvT"};